// extracted by mini-css-extract-plugin
var _1 = "ErrorPage-moduleError__OducW";
var _2 = "ErrorPage-modulelink__r3gUT";
var _3 = "ErrorPage-moduletext__klTkt";
var _4 = "ErrorPage-moduletitle__v43vs";
export { _1 as "Error", _2 as "link", _3 as "text", _4 as "title" }
